import React from 'react'
import {
  TableWrapper,
  TableEl,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  ActionsWrapper,
} from './CustomTable.styles'

export default function CustomTable({
  columns,
  data,
  showIndex = false,
  renderActions,
  getRowProps,
  onRowClick,
  compact = false,
}) {
  const hasActions = renderActions
    ? data.some((row) => {
        const el = renderActions(row)

        if (!el) return false
        if (React.isValidElement(el)) {
          const children = el.props?.children
          if (!children) return false
          if (Array.isArray(children)) {
            return children.some((c) => c !== null && c !== false && c !== '')
          }
          return children !== null && children !== false && children !== ''
        }
        return true
      })
    : false

  return (
    <TableWrapper $compact={compact}>
      <TableEl $compact={compact}>
        <TableHead>
          <TableRow>
            {showIndex && <TableHeader $compact={compact}>N°</TableHeader>}
            {columns.map((col) => (
              <TableHeader key={col.key} align={col.align} $compact={compact}>
                {col.label}
              </TableHeader>
            ))}
            {hasActions && (
              <TableHeader align="center" $compact={compact}>
                Acciones
              </TableHeader>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => {
            const extraProps = getRowProps ? getRowProps(row, idx) : {}
            const {
              onClick: extraOnClick,
              onKeyDown: extraOnKeyDown,
              ...restRowProps
            } = extraProps

            const handleClick = (event) => {
              extraOnClick?.(event)
              onRowClick?.(row, idx)
            }

            const handleKeyDown = (event) => {
              extraOnKeyDown?.(event)
              if (!onRowClick) return
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                onRowClick(row, idx)
              }
            }

            return (
              <TableRow
                key={row.id ?? idx}
                $clickable={Boolean(onRowClick)}
                tabIndex={onRowClick ? 0 : undefined}
                role={onRowClick ? 'button' : undefined}
                onClick={onRowClick || extraOnClick ? handleClick : undefined}
                onKeyDown={onRowClick || extraOnKeyDown ? handleKeyDown : undefined}
                {...restRowProps}
              >
                {showIndex && <TableCell $compact={compact}>{idx + 1}</TableCell>}
                {columns.map((col) => {
                  const cellValue = col.render
                    ? col.render(row[col.key], row)
                    : row[col.key]
                  return (
                    <TableCell
                      key={col.key}
                      align={col.align}
                      $compact={compact}
                      title={typeof cellValue === 'string' ? cellValue : ''}
                    >
                      {cellValue}
                    </TableCell>
                  )
                })}
                {hasActions && renderActions && (
                  <TableCell align="center" $compact={compact}>
                    <ActionsWrapper>{renderActions(row)}</ActionsWrapper>
                  </TableCell>
                )}
              </TableRow>
            )
          })}
        </TableBody>
      </TableEl>
    </TableWrapper>
  )
}
